<template>
    <el-dialog title="开户账号成功！" :visible.sync="show" width="25%" v-dialogDrag>
      <el-form :model="formData">
        <el-form-item label="用户名：" :label-width="formLabelWidth">
          <el-input v-model="formData.name" auto-complete="off" size="mini" style="width:200px" readonly></el-input>
        </el-form-item>
        <el-form-item label="用户编码：" :label-width="formLabelWidth">
          <el-input v-model="formData.code" auto-complete="off" size="mini" style="width:200px" readonly></el-input>
          <!-- <span>{{fromData.countryCode}}</span> -->
        </el-form-item>
        <el-form-item label="用户账号：" :label-width="formLabelWidth">
          <el-input v-model="formData.account" auto-complete="off" size="mini" style="width:200px" readonly></el-input>
        </el-form-item>
        <el-form-item label="用户密码：" :label-width="formLabelWidth">
          <el-input v-model="formData.password" auto-complete="off" size="mini" style="width:200px" readonly></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm(false)">确 定</el-button>
      </div>
    </el-dialog>
</template>

<script>
export default {
    props:{
        formLabelWidth:{
            Type:String,
            default(){
                return '100px';
            }
        }
    },
    data(){
       return {
           formData:{},
           show:false
       }
    },
    methods:{
        confirm(){
            let vm=this;            
            vm.show=false;
            vm.$emit("onConfirm",vm);
            vm.formData={};
        },
        /**
         * 显示数据
         */
        displayTenantInfo(data){
           if(!data){
               return;
           }
           let vm=this;
           vm.formData=data;
           vm.show=true;
        }
    }
}
</script>